export const TIMER_WIRELESS_BUTTON_MIN_FW = '2.5.29';
export const TIMER_HOUR_MINUTE_MIN_FW = '2.5.33';
export const PRIME_PRESSURE_MIN_FW = '2.5.20';

export const compareVersion = (a?: string, b?: string): number => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const left = a.split('.').map((x) => Number.parseInt(x, 10) || 0);
  const right = b.split('.').map((x) => Number.parseInt(x, 10) || 0);
  const len = Math.max(left.length, right.length);

  for (let i = 0; i < len; i += 1) {
    const lv = left[i] ?? 0;
    const rv = right[i] ?? 0;
    if (lv > rv) return 1;
    if (lv < rv) return -1;
  }

  return 0;
};

export const isTimerWirelessButtonSupported = (firmwareVersion?: string): boolean => {
  return compareVersion(firmwareVersion, TIMER_WIRELESS_BUTTON_MIN_FW) > 0;
};

export const isTimerHourMinuteSupported = (firmwareVersion?: string): boolean => {
  return compareVersion(firmwareVersion, TIMER_HOUR_MINUTE_MIN_FW) >= 0;
};

export const isPrimePressureSupported = (firmwareVersion?: string): boolean => {
  return compareVersion(firmwareVersion, PRIME_PRESSURE_MIN_FW) > 0;
};
